import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { LoadingScreen } from 'src/components/loading-screen';
import SubmittalsStatusProvider from 'src/components/submittals/submittals-status-wrapper';
import MainDashboardLayout from 'src/layouts/dashboard/main-layout';
import SubmittalsSideBarLayout from 'src/layouts/dashboard/submittals-SideBar-layout';
const SubmittalsDashboard = lazy(() => import('src/components/submittals/SideCards/dashboard'));
const Submittals = lazy(() => import('src/components/submittals/SideCards/submittals'));
const SubmittalsDetails = lazy(() =>
  import('src/components/submittals/SideCards/submittals-details')
);
const CreateSubmittals = lazy(() =>
  import('src/components/submittals/SideCards/submittals/create-submittals')
);
const SubmittalsPackage = lazy(() =>
  import('src/components/submittals/SideCards/submittals-package')
);
const CreateSubmittalsPackage = lazy(() =>
  import('src/components/submittals/SideCards/submittals-package/create-submittals-package')
);
const Transmittal = lazy(() => import('src/components/submittals/SideCards/transmittal'));
const CreateTransmittal = lazy(() =>
  import('src/components/submittals/SideCards/transmittal/create-transmittal')
);
const SubmittalsLibrary = lazy(() =>
  import('src/components/submittals/SideCards/submittals-library')
);
const CreateSubmittalsLibrary = lazy(() =>
  import('src/components/submittals/SideCards/submittals-library/create-submittals-library')
);

// ----------------------------------------------------------------------

export const SubmittalsRoutes = [
  {
    path: '/submittals',
    element: (
      <SubmittalsStatusProvider>
        <MainDashboardLayout>
          <SubmittalsSideBarLayout>
            <Suspense fallback={<LoadingScreen />}>
              <Outlet />
            </Suspense>
          </SubmittalsSideBarLayout>
        </MainDashboardLayout>
      </SubmittalsStatusProvider>
    ),
    children: [
      { element: <SubmittalsDashboard />, index: true },
      { path: 'submittals', element: <Submittals /> },
      { path: 'submittals/:id', element: <SubmittalsDetails /> },
      { path: 'create-submittals', element: <CreateSubmittals /> },
      { path: 'packages', element: <SubmittalsPackage /> },
      { path: 'create-package', element: <CreateSubmittalsPackage /> },
      { path: 'transmittal', element: <Transmittal /> },
      { path: 'create-transmittals', element: <CreateTransmittal /> },
      { path: 'library', element: <SubmittalsLibrary /> },
      { path: 'create-library', element: <CreateSubmittalsLibrary /> },
    ],
  },
];
